import { useState } from "react";

export const useCopyText = () => {
    const [copied, setCopied] = useState(false);

    const copy = (text) => {
        if (!text) return;
        
        navigator.clipboard.writeText(text).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        }).catch((err) => {
            console.error("Gagal menyalin teks: ", err);
        });
    };

    return { copied, copy };
};